import { Component, computed, input, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CmsLink } from '@models/copy/cms.model';
import { DeviceService } from '@services/device/device.service';

@Component({
  selector: 'app-link',
  standalone: true,
  imports: [RouterLink, NgClass],
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
})
export class LinkComponent {
  deviceService = inject(DeviceService);

  inputLink = input.required<CmsLink | null>();
  inputCss = input.required<string | null>();
  inputAriaLabel = input<string | null>();
  inputDataQa = input<string | null>();

  readonly image = computed(() =>
    this.deviceService.isMobile()
      ? this.inputLink()?.image?.mobileImage
      : this.inputLink()?.image?.desktopImage,
  );

  readonly imgWidthPx = computed(() => this.image()?.width ?? null);
  readonly imgHeightPx = computed(() => this.image()?.height ?? null);
  readonly objectPosX = computed(() => {
    const left = this.image()?.focalPoint?.left;
    return typeof left === 'number' ? `${left * 100}%` : null;
  });
  readonly objectPosY = computed(() => {
    const top = this.image()?.focalPoint?.top;
    return typeof top === 'number' ? `${top * 100}%` : null;
  });
}
